module.exports = __webpack_public_path__ + "static/media/heart-fill.7e0fa8b7.svg";